import { VokTeema } from '@finestmedia/vok'
import '@finestmedia/vok/dist/index.css'

import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { et } from 'vuetify/locale'

export const vuetify = createVuetify({
    components: { ...components },
    directives: { ...directives },
    locale: {
        locale: 'et',
        fallback: 'en',
        messages: { et }
    },
    theme: {
        defaultTheme: 'VokTeema',
        themes: {
            VokTeema,
        }
    }
});